import Swiper from 'swiper';
import {Navigation, Pagination, EffectCreative, Autoplay, Scrollbar} from 'swiper/modules'
Swiper.use([Pagination, Navigation, EffectCreative, Autoplay, Scrollbar]);

const testimonialSwiper = new Swiper('.slider-testimonials', {
  spaceBetween: 50,
  slidesPerView: 1,
  loop: true,
  breakpoints: {
    1400: {
      slidesPerView: 2,
    },
  },
  pagination: {
    el: ".testimonial-pagination",
  },
  navigation: {
    nextEl: '.testimonials-swiper-button-next',
    prevEl: '.testimonials-swiper-button-prev',
  },
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.testimonials a[href="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
    });
    link.style.pointerEvents = 'none';
    link.style.cursor = 'default';
  });
});
